import { render, staticRenderFns } from "./CmsTypeForm.vue?vue&type=template&id=3df31c4e&scoped=true&"
import script from "./CmsTypeForm.vue?vue&type=script&lang=js&"
export * from "./CmsTypeForm.vue?vue&type=script&lang=js&"
import style0 from "./CmsTypeForm.vue?vue&type=style&index=0&id=3df31c4e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df31c4e",
  null
  
)

export default component.exports